import { RequestService } from '../../../../../common/services/RequestService';
import { CATEGORIES_GET } from '../../constants';

export const getCategoriesRequest = payload => {
  return RequestService.get(CATEGORIES_GET);
};
